module.exports = __webpack_public_path__ + "static/media/Bayswater Ave Burlingame, CA2.577fcf79.jpg";